<script>
  import CrabIcon from "./icons/CrabIcon.svelte";
  import Progress from "./Progress.svelte";
</script>

<style>
  header {
    align-items: center;
    background: var(--white);
    display: flex;
    justify-content: space-between;
    height: 70px;
    padding-left: 2%;
    position: fixed;
    font-family: "Signika", sans-serif;
    width: 98%;
    box-shadow: var(--card-box-shadow);
    z-index: 300;
  }

  h1 {
    color: var(--black);
  }

  .user-area {
    display: flex;
    align-items: center;
    padding-right: 3%;
  }

  /* Sadly CSS variables do not support media queries */
  @media screen and (max-width: 768px) {
    header {
      justify-content: center;
      padding-left: 0;
      width: 100%;
    }

    button {
      display: block;
    }

    nav {
      box-shadow: var(--card-box-shadow);
      flex-direction: column;
      position: fixed;
      background: var(--white);
      height: 100vh;
      width: 80vw;
      top: 0;
      left: 0;
      justify-content: flex-start;
      align-items: flex-start;
      transform: translate(-80vw, 0);
      transition: transform 0.3s;
    }

    nav.active {
      transform: translate(0, 0);
    }

    h1 {
      align-self: center;
      white-space: nowrap;
    }

    .user-area {
      display: none;
    }
  }
</style>

<header>
  <h1>
    <CrabIcon className={'main-crab'} />
    Kani-Cram
  </h1>
  <div class="user-area">
    <Progress />
  </div>

</header>
